import { render, staticRenderFns } from "./PrintTagComponent.vue?vue&type=template&id=4207d863&scoped=true&"
import script from "./PrintTagComponent.vue?vue&type=script&lang=js&"
export * from "./PrintTagComponent.vue?vue&type=script&lang=js&"
import style0 from "./PrintTagComponent.vue?vue&type=style&index=0&id=4207d863&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4207d863",
  null
  
)

export default component.exports